<template>
<div class="j-super-query-box" v-show="superQueryFlag" :style="{marginLeft: !superQueryFlag?'-20px':''}">
  <slot name="button" :isActive="superQueryFlag" :isMobile="izMobile" :open="handleOpen" :reset="clear">
    <a-tooltip v-if="superQueryFlag"  v-bind="tooltipProps" :mouseLeaveDelay="0.2">
        <div @click="clear" class="super-search-btn" >
          <span>
            <icon-font :type="'icon-quxiaolianjie'"
                       style="width: 20px;"></icon-font>
          </span>
          <h4>
            取消筛选
          </h4>

        </div>
    </a-tooltip>
  </slot>

  <j-modal
    title="高级查询构造器"
    :width="574"
    :visible="visible"
    :closable="false"
    @cancel="handleCancel"
    :mask="false"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top:5%;max-height: 95%;"
  >

    <template slot="footer">
      <a-button :loading="loading" style="width: 93px" type="primary" @click="handleOk">确定</a-button>
      <a-button :loading="loading" style="width: 93px" @click="handleCancel">关闭</a-button>
    </template>

    <a-spin :spinning="loading">
      <div class="super-top">
        <div style="color: #0A1629;">条件筛选</div>
        <div style="color: #7D8592;cursor: pointer"  @click="handleResetThis">清空条件</div>
      </div>
      <a-row style="padding: 24px">
        <a-col :sm="24" :md="24">

          <!--<a-empty v-if="queryParamsModel.length === 0" style="margin-bottom: 12px;">-->
            <!--<div slot="description">-->
              <!--<span>没有任何查询条件</span>-->
              <!--<a-divider type="vertical"/>-->
              <!--<a @click="handleAdd">点击新增</a>-->
            <!--</div>-->
          <!--</a-empty>-->

          <a-form layout="inline">

            <a-row style="margin-bottom: 24px;">
              <a-col :md="24" :xs="24">
                <div class="filter-box">
                  <div style="width: 100px;color:#7D8592;">过滤条件：</div>
                  <a-radio-group v-model:value="matchType" style="width: 100%;">
                    <a-radio value="and" style="color: #0A1629;font-size: 14px">所有条件需满足</a-radio>
                    <a-radio value="or"  style="color: #0A1629;font-size: 14px">其中一条满足</a-radio>
                  </a-radio-group>
                </div>
              </a-col>
            </a-row>

            <a-row v-if="item.field==superName" type="flex" style="margin-bottom:10px;" :gutter="16" v-for="(item, index) in queryParamsModel" :key="index">

              <!--<a-col :md="8" :xs="24" style="margin-bottom: 12px;">-->
                <!--<a-tree-select-->
                  <!--showSearch-->
                  <!--v-model="item.field"-->
                  <!--:treeData="fieldTreeData"-->
                  <!--:dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"-->
                  <!--placeholder="选择查询字段"-->
                  <!--allowClear-->
                  <!--treeDefaultExpandAll-->
                  <!--:getPopupContainer="node=>node.parentNode"-->
                  <!--style="width: 100%"-->
                  <!--@select="(val,option)=>handleSelected(option,item)"-->
                <!--&gt;-->
                <!--</a-tree-select>-->
              <!--</a-col>-->

              <a-col :md="6" :xs="24" style="margin-bottom: 12px;">
                <a-select placeholder="匹配规则" :value="item.rule" :getPopupContainer="node=>node.parentNode" @change="handleRuleChange(item,$event)">
                  <a-select-option :value="a.value" v-if="item.showRule['list']" v-for="a in item.list">{{a.name}}</a-select-option>

                  <a-select-option value="eq" v-if="item.showRule['eq']">等于</a-select-option>
                  <a-select-option value="like" v-if="item.showRule['like']" >包含</a-select-option>
                  <a-select-option value="locate" v-if="item.showRule['locate']">不包含</a-select-option>
                  <a-select-option value="not_like" v-if="item.showRule['not_like']">包含</a-select-option>
                  <a-select-option value="ne" v-if="item.showRule['ne']" >不等于</a-select-option>
                  <a-select-option value="gt" v-if="item.showRule['gt']&&item.type!='month'&&item.type!='datetime'">大于</a-select-option>
                  <a-select-option value="gt" v-if="item.showRule['gt']&&(item.type=='month'||item.type=='datetime')">之后</a-select-option>
                  <a-select-option value="ge"  v-if="item.showRule['ge']">大于等于</a-select-option>
                  <a-select-option value="lt"  v-if="item.showRule['lt']&&item.type!='month'&&item.type!='datetime'" >小于</a-select-option>
                  <a-select-option value="lt"  v-if="item.showRule['lt']&&(item.type=='month'||item.type=='datetime')" >之前</a-select-option>
                  <a-select-option value="le"  v-if="item.showRule['le']" >小于等于</a-select-option>
                  <a-select-option value="not_null"  v-if="item.showRule['not_null']&&!item.yesNo">不为空</a-select-option>
                  <a-select-option value="not_null"  v-if="item.showRule['not_null']&&item.yesNo">是</a-select-option>
                  <a-select-option value="is_null"  v-if="item.showRule['is_null']&&!item.yesNo">为空</a-select-option>
                  <a-select-option value="is_null"  v-if="item.showRule['is_null']&&item.yesNo">否</a-select-option>
                  <a-select-option value="left_like" v-if="item.showRule['left_like']">以...结尾</a-select-option>
                </a-select>
              </a-col>

              <a-col :md="15" :xs="24" style="margin-bottom: 12px;">
                <!-- 下拉搜索 -->
                <j-search-select-tag v-if="item.type==='sel_search'&&item.dictCode&& item.rule!='not_null'&&item.rule!='is_null'" v-model="item.val" :dict="getDictInfo(item)" placeholder="请选择"/>
                <j-search-select-tag v-if="item.type==='sel_search'&&item.options&& item.rule!='not_null'&&item.rule!='is_null'" v-model="item.val" :dictOptions="item.options" placeholder="请选择"/>
                <!-- 下拉多选 -->
                <template v-else-if="item.type==='list_multi'">
                  <j-multi-select-tag v-if="item.options" v-model="item.val" :options="item.options" placeholder="请选择"/>
                  <j-multi-select-tag v-else v-model="item.val" :dictCode="getDictInfo(item)" placeholder="请选择"/>
                </template>

                <template v-else-if="item.dictCode && item.rule!='not_null'&&item.rule!='is_null'">
                  <template v-if="item.type === 'table-dict'">
                    <j-popup
                      v-model="item.val"
                      :code="item.dictTable"
                      :field="item.dictCode"
                      :orgFields="item.dictCode"
                      :destFields="item.dictCode"
                      :multi="true"
                    ></j-popup>
                  </template>
                  <template v-else>
                    <j-multi-select-tag v-show="allowMultiple(item)" v-model="item.val" :dictCode="item.dictCode" placeholder="请选择"/>
                    <j-dict-select-tag v-show="!allowMultiple(item)" v-model="item.val" :dictCode="item.dictCode" placeholder="请选择"/>
                  </template>
                </template>
                <j-popup
                  v-else-if="item.type === 'popup'"
                  :value="item.val"
                  v-bind="item.popup"
                  group-id="superQuery"
                  @input="(e,v)=>handleChangeJPopup(item,e,v)"
                  :multi="true"/>
                <j-select-multi-user
                  v-else-if="item.type === 'select-user' || item.type === 'sel_user'"
                  v-model="item.val"
                  :buttons="false"
                  :multiple="false"
                  placeholder="请选择用户"
                  :returnKeys="['id', item.customReturnField || 'username']"
                />
                <j-select-depart
                  v-else-if="item.type === 'select-depart' || item.type === 'sel_depart'"
                  v-model="item.val"
                  :multi="false"
                  placeholder="请选择部门"
                  :customReturnField="item.customReturnField || 'id'"
                />
                <a-select
                  v-else-if="item.options instanceof Array  && item.rule!='not_null'&&item.rule!='is_null' && item.rule!='gt' && item.rule!='lt'"
                  v-model="item.val"
                  :options="item.options"
                  allowClear
                  placeholder="请选择"
                  :mode="allowMultiple(item)?'multiple':''"
                />

                <j-area-linkage v-model="item.val" v-else-if="item.type==='area-linkage' || item.type==='pca'" style="width: 100%"/>
                <j-date v-else-if=" item.type=='date'&&item.rule!='like' || (item.type=='month' && item.rule!='like') " v-model="item.val" placeholder="请选择日期" style="width: 100%"></j-date>
                <a-month-picker v-else-if=" item.type=='month' " v-model:value="item.val" valueFormat="yyyy-MM" placeholder="请选择月份" />
                <a-range-picker v-else-if="item.type=='date'&&item.rule=='like'"  v-model="item.val"  :bordered="false" />
                <j-date v-else-if=" item.type=='datetime' " v-model="item.val" placeholder="请选择时间" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%"></j-date>
                <a-time-picker v-else-if="item.type==='time'" :value="item.val ? moment(item.val,'HH:mm:ss') : null" format="HH:mm:ss" style="width: 100%" @change="(time,value)=>item.val=value"/>
                <a-input-number v-else-if=" item.type=='int'||item.type=='number' " style="width: 100%" placeholder="请输入数值" v-model="item.val"/>
                <a-select v-else-if="item.type=='switch'" placeholder="请选择" v-model="item.val">
                  <a-select-option value="Y">是</a-select-option>
                  <a-select-option value="N">否</a-select-option>
                </a-select>
                <a-input v-else-if="item.rule!='not_null'&&item.rule!='is_null'" @change="filter(item,item.filter)" v-model="item.val" placeholder="请输入值"/>
              </a-col>


              <a-col :md="3" :xs="0" style="margin-bottom: 12px;padding-left: 8px">
                <!--<a-button @click="handleAdd" icon="plus"></a-button>&nbsp;-->
                <a-button @click="handleDel( index )" icon="minus" style="width: 48px"></a-button>
              </a-col>

              <a-col :md="0" :xs="24" style="margin-bottom: 12px;text-align: right;">
                <a-button @click="handleAdd" icon="plus"></a-button>&nbsp;
                <a-button @click="handleDel( index )" icon="minus"></a-button>
              </a-col>

            </a-row>

          </a-form>
        </a-col>
        <a-col :sm="24" :md="24">
          <div class="add-filter" @click="handleAdd">
            <a-icon type="plus" style="color: #0A1629"></a-icon>
            <span style="margin-left: 7px">增加条件</span>
          </div>
        </a-col>
      </a-row>


    </a-spin>


  </j-modal>


  <a-drawer title="筛选器" :width="400"
           :footer="null"
           class="sxq-box"
            placement="left"
           :bodyStyle="bodyStyle"
           :visible="superVisible" @close="superVisible = false">
    <div class="customer-filter-panel">
      <!-- 当前分组 -->
      <div class="filter-group">
        <div class="group-title">当前</div>
        <div class="filter-item current-tag" @click="showSaveBox()">
          <span>{{searchName}}</span>
          <a-icon type="save" class="save-icon" />
        </div>
      </div>
<!--      <a-divider style="color: #E6EDF5" v-if="commonData.length || (commonSearch && commonSearch.length)"></a-divider>-->
<!--      &lt;!&ndash; 通用分组 &ndash;&gt;-->
<!--      <div class="filter-group"  v-if="commonData.length || (commonSearch && commonSearch.length)">-->
<!--        <div class="group-title">通用</div>-->
<!--        <div class="filter-list">-->
<!--          <div-->
<!--            class="filter-item"-->
<!--            @click="toSearchQuery(item)"-->
<!--            v-if="commonSearch && commonSearch.length"-->
<!--            v-for="item in commonSearch"-->
<!--          >-->
<!--            <span>{{item.title}}<span style="color: red;margin-left: 5px;font-weight: bold" v-if="item.num">{{item.num}}</span></span>-->
<!--            <a-icon type="right-circle-o" @click.stop="editSaveSearch(item)" class="check-icon" />-->
<!--          </div>-->
<!--          <div-->
<!--            class="filter-item"-->
<!--            v-for="item in commonData"-->
<!--            @click="toSearch(item)"-->
<!--          >-->
<!--            <span>{{item.originTitle}}</span>-->
<!--            <a-icon type="right-circle-o" @click.stop="editSaveSearch(item)" class="check-icon" />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <a-divider style="color: #E6EDF5" v-if="saveTreeData.length"></a-divider>
      <!-- 我的保存分组 -->
      <div class="filter-group"  v-if="saveTreeData.length">
        <div class="group-title">我的保存</div>
        <div class="filter-list">
          <div class="filter-item" @click="toSearch(item)" v-for="item in saveTreeData">
            <span>{{item.originTitle}}</span>
            <a-icon type="edit" @click.stop="editSaveSearch(item)" class="edit-icon" />
          </div>
        </div>
      </div>
    </div>

  </a-drawer>

  <a-modal :width="500"
           :footer="null"
           :bodyStyle="bodyStyle"
           title="筛选条件" :visible="prompt.visible" @cancel="prompt.visible=false" @ok="handlePromptOk">

    <div class="filter-config-container">
      <!-- 筛选器名称区域 -->
      <div class="filter-name-section">
        <div class="label">筛选器名称</div>
        <a-input
          v-model:value="saveData.title"
          :disabled="saveData.type===1"
          class="filter-name-input"
          placeholder="请输入筛选器名称"
        />
        <div class="button-group" v-if="saveData.type===2">
          <a-button
            type="default"
            class="delete-btn"
            v-if="saveData.id"
            @click="handleDeleteSearch"
          >
            删除
          </a-button>
          <a-button
            type="primary"
            class="save-btn"
            @click="handleSaveSearch"
          >
            保存
          </a-button>
        </div>
        <div v-else style="color: #999999;float: inline-end;">
          通用模板不支持编辑
        </div>
      </div>

      <!-- 包含条件区域 -->
      <div class="condition-section">
        <div class="section-title" style="margin-bottom: 10px">包含条件</div>
        <div class="description-container" v-if="saveData.commonValue && saveData.commonValue.searchValue &&  saveData.commonValue.searchValue.length">
          <!-- 第一行 -->
          <div class="description-item" v-for="item in saveData.commonValue.searchValue">
            <div class="description-label">{{item.text}}：</div>
            <div class="description-content">'{{getContion(item)}}'&nbsp;&nbsp;&nbsp;&nbsp;{{item.valText?`'${item.valText}'`:(item.val?`'${item.val}'`:'')}}</div>
          </div>

        </div>
        <div class="description-container" v-if="saveData.searchValue && saveData.searchValue.length">

          <div class="description-item" v-for="item in saveData.searchValue">
            <div class="description-label">{{item.text}}：</div>
            <div class="description-content">'{{getContion(item)}}'&nbsp;&nbsp;&nbsp;&nbsp;{{item.valText?`'${item.valText}'`:(item.val?`'${item.val}'`:'')}}</div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</div>
</template>

<script>
  import moment from 'moment'
  import * as utils from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import JDate from '@/components/jeecg/JDate.vue'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSelectMultiUser from '@/components/jeecgbiz/JSelectMultiUser'
  import JMultiSelectTag from '@/components/dict/JMultiSelectTag'
  import JAreaLinkage from '@comp/jeecg/JAreaLinkage'
  import ACol from "ant-design-vue/es/grid/Col";
  import { getAction,httpAction ,deleteAction} from '@/api/manage'
  import {getDictItemsFromCacheText} from '@/api/api'
  import eventBus from '@/utils/eventBus'
  export default {
    name: 'JSuperQueryNew',
    mixins: [mixinDevice],
    components: {ACol, JAreaLinkage, JMultiSelectTag, JDate, JSelectDepart, JSelectMultiUser },
    props: {
      /*
       fieldList: [{
          value:'',
          text:'',
          type:'',
          dictCode:'' // 只要 dictCode 有值，无论 type 是什么，都显示为字典下拉框
       }]
       type:date datetime int number string
      * */
      fieldList: {
        type: Array,
        required: true
      },
      /*
      * 这个回调函数接收一个数组参数 即查询条件
      * */
      callback: {
        type: String,
        required: false,
        default: 'handleSuperQuery'
      },

      // 当前是否在加载中
      loading: {
        type: Boolean,
        default: false
      },

      // 保存查询条件的唯一 code，通过该 code 区分
      // 默认为 null，代表以当前路由全路径为区分Code
      saveCode: {
        type: String,
        default: null
      },commonSearch: {
        type: Array,
        required: false,
        default: []
      }

    },
      data() {
      return {
        moment,
        fieldTreeData: [],

        prompt: {
          visible: false,
          value: ''
        },
        visible: false,
        queryParamsModel: [],
        treeIcon: <a-icon type="file-text"/>,
        // 保存查询条件的treeData
        saveTreeData: [],
        commonData:[],
        // 保存查询条件的前缀名
        saveCodeBefore: 'JSuperQuerySaved_',
        // 查询类型，过滤条件匹配（and、or）
        matchType: 'and',
        superQueryFlag: false,
        dateFormat:'YYYY-MM-DD',
        treeIndex:0,
          superName:'',
        searchName:'',
        superVisible:false,
        bodyStyle:{
          background:'#F4F9FD',
        },
        labelStyle:{
          fontSize:'16px',
          color:'#333333',
        },
        saveData:{
          title:'',
        },
        chooseSearch:'',
        serachParamMap:{

        },commonItem:null
      }
    },
    computed: {
      izMobile() {
        return this.device === 'mobile'
      },
      tooltipProps() {
        return this.izMobile ? { visible: false } : {}
      },
      fullSaveCode() {
        let saveCode = this.saveCode
        if (saveCode == null || saveCode === '') {
          saveCode = this.$route.fullPath
        }
        return this.saveCodeBefore + saveCode
      },
    },
    watch: {
      saveCode:{
        immediate: true,
        handler(n,o) {
          this.setDefaultSearchName();
        }
      },
      // 当 saveCode 变化时，重新查询已保存的条件
      superVisible: {
        immediate: true,
        handler(n,o) {
          console.log(n,o)
          if( n){
            this.serachParamMap = {}
            this.chooseSearch = ''
            this.loadCommonSearchParam();
            this.loadSearchParam();
          }

        }
      },
      fieldList: {
        deep: true,
        immediate: true,
        handler(val) {
          let mainData = [], subData = []
          val.forEach(item => {
            let data = { ...item }
            data.label = data.label || data.text
            let hasChildren = (data.children instanceof Array)
            data.disabled = hasChildren
            data.selectable = !hasChildren
            if (hasChildren) {
              data.children = data.children.map(item2 => {
                let child = { ...item2 }
                child.label = child.label || child.text
                child.label = data.label + '-' + child.label
                child.value = data.value + ',' + child.value
                child.val = ''
                return child
              })
              data.val = ''
              subData.push(data)
            } else {
              mainData.push(data)
            }
          })

          this.fieldTreeData = mainData.concat(subData)
          console.log(this.fieldTreeData)
        }
      }
    },

    methods: {
      clear(){
        if(this.commonSearch){
          let cm = null;
          for(let a in this.commonSearch){
            if(this.commonSearch[a].isAll){
              cm = this.commonSearch[a];
            }
          }
          this.toSearchQuery( cm);
        }
        this.superQueryFlag = false
      },
      // 静默重置条件：只清弹窗内部状态，不发 handleSuperQuery 事件。
      // clear() 会 emit 触发页面重查；目录切换恢复无缓存时只需要清 UI，
      // 重查由 init() 负责，否则每个新目录首次进入都会重复请求一次列表
      silentClear(){
        this.queryParamsModel = []
        this.superQueryFlag = false
      },
      show() {
        let hasModel = false;
        for(let a in this.queryParamsModel){
          if(this.queryParamsModel[a].field == this.superName){
            hasModel = true;
            break;
          }
        }
        if(!hasModel){
          this.addNewLine()
        }
        this.visible = true
      },

      getDictInfo(item) {
        let str = ''
        if(!item.dictTable){
          str = item.dictCode
        }else{
          str = item.dictTable+','+item.dictText+','+item.dictCode
        }
        console.log('高级查询字典信息',str)
        return str
      },
      handleOk() {

        if (!this.isNullArray(this.queryParamsModel)) {
          let str = this.getSearchStr();
          console.log('高级查询条件str):',str)
          console.log('高级查询条件this.serachParamMap:',this.serachParamMap)
          if(this.serachParamMap[ str]){
            this.searchName = this.serachParamMap[ str];
          }else{
            this.searchName = '用户自定义'
          }
          this.visible = false;
          this.searchOk();
        } else {
          //this.setDefaultSearchName();
          this.$message.warn("不能查询空条件")
          this.searchOk();
        }
      },getSearchText(value,commonValue){
        let list = [];
        for(let a in value){
          if((value[a].rule=='not_null' || value[a].rule=='is_null') || value[a].val){
            let obj ={
              field:value[a].field,
              str : value[a].field+'+'+value[a].rule+'+'+value[a].val
            }
            list.push( obj);
          }
        }
        list.sort(utils.by_str('field'))
        let str = list.map(item=>item.str).join('&');
        if(commonValue){
          str= commonValue.title +'&'+str;
        }
        console.log('高级查询条件str:',str)
        return str;
      },getSearchStr(){
        let str = '';
        if(this.queryParamsModel){
          str = this.getSearchText(this.queryParamsModel,this.commonItem);
        }
        return str;
      },searchOk(){
        let event = {
          matchType: this.matchType,
          params: this.removeEmptyObject(this.queryParamsModel)
        }
        console.debug('---event--->', event)
        // 移动端模式下关闭弹窗
        if (this.izMobile) {
          this.visible = false
        }
        this.emitCallback(event);
        let map = {}
        if(event.params){
          for(let a in event.params){
            if(event.params[a].val || event.params[a].rule == 'is_null'){
              map[event.params[a].field] = 1;
            }
          }
        }
        this.$emit("change",map)
        // 条件变化后与已保存模板对比：完全匹配则显示"更改模板名"，否则显示"设为常用模板"
        this.notifyTemplateMatch()
      },
      // 当前条件组合与已保存模板比对，通知全局工具栏切换模板按钮状态
      notifyTemplateMatch() {
        let matched = this.findMatchedTemplate(this.queryParamsModel)
        if (matched) {
          eventBus.$emit('template-applied', matched)
        } else {
          eventBus.$emit('template-mismatched')
        }
      },
      findMatchedTemplate(params) {
        if (!params || params.length === 0) return null
        let list = this.saveTreeData || []
        for (let i = 0; i < list.length; i++) {
          let tpl = list[i]
          if (this.isSameConditions(params, tpl.records || [])) return tpl
        }
        return null
      },
      // 两个条件数组是否完全一致（field/rule/val 相同，忽略顺序）
      isSameConditions(a, b) {
        if (a.length !== b.length) return false
        let norm = (arr) => arr.map(x => (x.field || '') + '|' + (x.rule || '') + '|' + (x.val === undefined || x.val === null ? '' : x.val)).sort().join('&&')
        return norm(a) === norm(b)
      },
      emitCallback(event = {}) {
        let { params = [], matchType = this.matchType } = event
        this.superQueryFlag = (params && params.length > 0)
        this.superQueryFlag = true;
        for (let param of params) {
          if (Array.isArray(param.val)) {
            param.val = param.val.join(',')
          }
        }
         let queryParam = {};
        if(this.commonItem){
          queryParam = this.commonItem.queryParam;
        }
        // for(let p in this.commonSearch){
        //   if(this.commonSearch[p].isAll){
        //     queryParam = this.commonSearch[p].queryParam;
        //     break;
        //   }
        // }
        this.$emit(this.callback, params, matchType,queryParam)
      },emitCallbackQuery(item){
        this.superQueryFlag = true;
        this.$emit(this.callback, [], this.matchType,item.queryParam)
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleAdd() {
        this.addNewLine()
      },
      addNewLine() {
        let item = { rule: 'eq' ,showRule:{"eq":true}};
        item =  this.handleSelected(item);
        this.queryParamsModel.push(item);

      },
      resetLine() {
        this.superQueryFlag = false
        this.queryParamsModel = []
        console.log(this.queryParamsModel)
        this.addNewLine()
      },
      handleDel(index) {
        this.queryParamsModel.splice(index, 1)
      },
      handleSelected(item) {
        let { type, options, dictCode, dictTable, dictText, customReturnField, popup ,showRule,defaultRule,list,yesNo,value,text} = this.fieldTreeData[this.treeIndex];
        item['yesNo'] = yesNo
        item['field'] = value
        item['type'] = type
        item['options'] = options
        item['dictCode'] = dictCode
        item['dictTable'] = dictTable
        item['list'] = list
        item['dictText'] = dictText
        item['showRule'] = showRule
        item['defaultRule'] = defaultRule
        item['customReturnField'] = customReturnField
        item['text'] = text
        if (popup) {
          item['popup'] = popup
        }
        this.$set(item, 'val', undefined)
        item.rule = defaultRule;
        return item;
      },
      handleOpen(superName) {
        let tree = this.fieldTreeData;
        let index = 0;
        for(let a in tree){
          if(tree[a].value==superName){
            index=a;
            break;
          }
        }
        this.treeIndex = index;
        this.superName = superName;
        this.show()
      },
      handleReset() {
        // this.resetLine()
        // this.emitCallback()
        // this.$emit("change",{});
        this.superVisible = true;
      },handleResetThis(){
        let queryParamsModel = this.queryParamsModel;
        this.queryParamsModel = queryParamsModel.filter(item => item.field !== this.superName);
        let hasSearch = false;
        for(let a in this.queryParamsModel){
          if(this.queryParamsModel[a].val){
            hasSearch = true;
          }
        }
        if(hasSearch){
          let str = this.getSearchStr();
          console.log('高级查询条件str):',str)
          console.log('高级查询条件this.serachParamMap:',this.serachParamMap)
          if(this.serachParamMap[ str]){
            this.searchName = this.serachParamMap[ str];
          }else{
            this.searchName = '用户自定义'
          }
          this.visible = false;
          this.searchOk();
        }else{
          //this.setDefaultSearchName();
          this.resetLine()
          this.emitCallback()
          this.$emit("change",{});
        }

      },
      handleSave() {
        let queryParams = this.removeEmptyObject(this.queryParamsModel)
        if (this.isNullArray(queryParams)) {
          this.$message.warning('空条件不能保存')
        } else {
          this.prompt.value = ''
          this.prompt.visible = true
        }
      },
      handlePromptOk() {
        let { value } = this.prompt
        if(!value){
          this.$message.warning('保存名称不能为空')
          return
        }
        // 取出查询条件
        let records = this.removeEmptyObject(this.queryParamsModel)
        // 判断有没有重名的
        let filterList = this.saveTreeData.filter(i => i.originTitle === value)
        if (filterList.length > 0) {
          this.$confirm({
            content: `${value} 已存在，是否覆盖？`,
            onOk: () => {
              this.prompt.visible = false
              filterList[0].records = records
              this.saveToLocalStore()
              this.$message.success('保存成功')
            }
          })
        } else {
          // 没有重名的，直接添加
          this.prompt.visible = false
          // 添加到树列表中
          this.saveTreeData.push(this.renderSaveTreeData({
            title: value,
            matchType: this.matchType,
            records: records
          }))
          // 保存到 LocalStore
          this.saveToLocalStore()
          this.$message.success('保存成功')
        }
      },
      handleTreeSelect(idx, event) {
        if (event.selectedNodes[0]) {
          let { matchType, records } = event.selectedNodes[0].data.props
          // 将保存的matchType取出，兼容旧数据，如果没有保存就还是使用原来的
          this.matchType = matchType || this.matchType
          this.queryParamsModel = utils.cloneObject(records)
        }
      },toSearch(item){
        this.matchType = item.matchType || this.matchType
        this.queryParamsModel = utils.cloneObject(item.records);
        this.commonItem = utils.cloneObject(item.commonValue);
        this.searchOk();
        // 应用了已保存的筛选模板：通知全局工具栏匹配该模板（显示"更改模板名/删除模板"而非"设为常用模板"）
        eventBus.$emit('template-applied', item)
        this.superVisible = false;
        this.searchName = item.title;
        this.chooseSearch = this.getSearchStr();
      },toSearchQuery( item){
         this.resetLine()
         this.emitCallbackQuery(item);
         this.$emit("change",{});
         this.searchName = item.title;
         this.commonItem = item;
         this.superVisible = false;
         // if(item.isAll){
         //   this.superQueryFlag = false;
         // }
      },
      handleRemoveSaveTreeItem(event, vNode) {
        // 阻止事件冒泡
        event.stopPropagation()

        this.$confirm({
          content: '是否删除当前查询？',
          onOk: () => {
            let { eventKey } = vNode
            this.saveTreeData.splice(Number.parseInt(eventKey.substring(2)), 1)
            this.saveToLocalStore()
          },
        })
      },

      // 将查询保存到 LocalStore 里
      saveToLocalStore() {
        let saveValue = this.saveTreeData.map(({ originTitle, matchType, records }) => ({ title: originTitle, matchType, records }))
        this.$ls.set(this.fullSaveCode, saveValue)
      },

      isNullArray(array) {
        //判断是不是空数组对象
        if (!array || array.length === 0) {
          return true
        }
        if (array.length === 1) {
          let obj = array[0]
          if ((!obj.field || (obj.val == null || obj.val === '') || !obj.rule)&& obj.rule!='not_null'&&obj.rule!='is_null') {
            return true
          }
        }
        return false
      },
      // 去掉数组中的空对象
      removeEmptyObject(arr) {
        console.log("arr",arr)
        let array = utils.cloneObject(arr)
        for (let i = 0; i < array.length; i++) {
          let item = array[i]
          if (item == null || Object.keys(item).length <= 0
            || (item.rule!=='not_null'&& item.rule!=='is_null' &&!item.val)) {
            array.splice(i--, 1)
          } else {
            if (Array.isArray(item.options)) {
              if(item.val!==undefined){
                this.getValTextFormOption( item);
              }
              // 如果有字典属性，就不需要保存 options 了
              //update-begin-author:taoyan date:20200819 for:【开源问题】 高级查询 下拉框作为并且选项很多多多 LOWCOD-779
              delete item.options
              //update-end-author:taoyan date:20200819 for:【开源问题】 高级查询 下拉框作为并且选项很多多多 LOWCOD-779
            }else if(item.dictCode && item.val!==undefined && item.val!==null){
               item.valText = getDictItemsFromCacheText(item.dictCode,item.val)
            }
          }
        }
        return array
      },getValTextFormOption( item){
        if(item.options){
          for(let a in item.options){
            if(item.options[a].value==item.val){
              item.valText = item.options[a].text
              break;
            }
          }
        }
      },

      /** 渲染保存查询条件的 title（加个删除按钮） */
      renderSaveTreeData(item) {
        item.originTitle = item.title;
        item.searchValue = JSON.parse(item.searchValue);
        item.commonValue = JSON.parse(item.commonValue);
        item.records = item.searchValue;
        let str = this.getSearchText(item.searchValue,item.commonValue);
        this.serachParamMap[str] = item.title;
        return item
      },

      /** 判断是否允许多选 */
      allowMultiple(item) {
        return item.rule === 'in'
      },

      handleRuleChange(item, newValue) {
        debugger;
        let oldValue = item.rule
        this.$set(item, 'rule', newValue)
        // 上一个规则是否是 in，且type是字典或下拉
        if (oldValue === 'in') {
          if (item.dictCode || item.options instanceof Array) {
            let value = item.val
            if (typeof item.val === 'string') {
              value = item.val.split(',')[0]
            } else if (Array.isArray(item.val)) {
              value = item.val[0]
            }
            this.$set(item, 'val', value)
          }
        }else{
          item.val = null;
        }
      },

      handleChangeJPopup(item, e, values) {
        item.val = values[item.popup['destFields']]
      },filter(item,f){
        if(item.val){
          item.val = item.val.trim();
        }
        if(!f){
          return;
        }
        item.val = item.val.replace(`/${f}/g`,'');
      },loadSearchParam(){
        this.saveTreeData = [];
        getAction("/dm/dmSearchParam/selectMySearchList",{
          saveCode:this.fullSaveCode
        }).then(res=>{
          if(res.success){
            let list =  res.result;
            if( list){
              for (let i = 0; i < list.length; i++){
                this.saveTreeData.push(this.renderSaveTreeData(list[i]));
              }
            }
            // 同步已保存模板到全局布局的二级菜单目录（保存/删除后都会走这里，单一出口）
            eventBus.$emit('filter-templates-loaded', {
              saveCode: this.fullSaveCode,
              list: this.saveTreeData.map(i => ({ id: i.id, title: i.title, matchType: i.matchType, records: i.records, commonValue: i.commonValue }))
            })
          }
        }).catch(()=>{})
      },loadCommonSearchParam(){
        this.commonData = []
        getAction("/dm/dmSearchParam/selectCommonList",{
          saveCode:this.fullSaveCode
        }).then(res=>{
          if(res.success){
            let list =  res.result;
            if( list){
              for (let i = 0; i < list.length; i++){
                this.commonData.push(this.renderSaveTreeData(list[i]));
              }
            }
          }
        }).catch(()=>{})
      },deleteTemplate(tpl){
        // 全局工具栏「删除模板」入口：按传入模板 id 删除
        if (tpl && tpl.id) {
          this.saveData = { id: tpl.id, title: tpl.title }
          this.handleDeleteSearch()
        }
      },handleDeleteSearch(){
        deleteAction("/dm/dmSearchParam/delete",{id:this.saveData.id}).then(res=>{
           if(res.success){
             this.$message.success('删除成功');
             this.prompt.visible = false;
             this.loadSearchParam();
           }else{
             this.$message.error(res.message);
           }
         })
      },handleSaveSearch(){
        if(!this.saveData.title){
          this.$message.error('请输入筛选器名称');
          return;
        }
        let saveData = JSON.parse(JSON.stringify(this.saveData));
        saveData.saveCode = this.fullSaveCode;
        saveData.type= 2;
        saveData.searchValue = JSON.stringify(saveData.searchValue);
        saveData.commonValue = JSON.stringify(this.commonItem);
        getAction("/dm/dmSearchParam/checkHasName",saveData).then(res=>{
          if(res.success){
            httpAction("/dm/dmSearchParam/save",saveData,"post").then(res=>{
              if(res.success){
                this.$message.success('保存成功');
                this.prompt.visible = false;
                this.loadSearchParam();
                // 保存成功：当前条件组合已成为模板，通知全局工具栏匹配（显示"更改模板名"）
                eventBus.$emit('template-applied', {
                  title: saveData.title,
                  records: saveData.searchValue ? JSON.parse(saveData.searchValue) : [],
                  matchType: saveData.matchType,
                  commonValue: this.commonItem
                })
              }else{
                this.$message.error(res.message);
              }
            })
          }else{
            this.$message.error(res.message);
          }
        });
      },showSaveBox(){
        let item = null;
        if(this.saveTreeData) {
          for(let v in this.saveTreeData){
            if(this.saveTreeData[v].title === this.searchName){
              item = this.saveTreeData[v];
              break;
            }
          }
        }
        if(!item && this.commonSearch){
          for(let v in this.commonSearch){
            if(this.commonSearch[v].title === this.searchName){
              item = this.commonSearch[v];
              break;
            }
          }
        }
        if(!item && this.commonData){
          for(let v in this.commonData){
            if(this.commonData[v].title === this.searchName){
              item = this.commonData[v];
              break;
            }
          }
        }
        if(!item){
          let records = this.removeEmptyObject(this.queryParamsModel)
          let matchType = this.matchType;
          this.prompt.visible = true;
          this.saveData = {
            searchValue:records,
            matchType:matchType,
            type:2,
            commonValue:this.commonItem
          }
        }else {
          this.editSaveSearch(item);
        }
      },editSaveSearch(item){
        this.prompt.visible = true;
        this.saveData = utils.cloneObject(item);
        console.log(this.saveData)
      },getContion(item){
        switch ( item.rule) {
          case "eq":
            return '等于';
          case "ne":
            return '不等于';
          case "like":
            return '包含';
          case "gt":
            if(item.type!='month'&&item.type!='datetime'){
              return '大于';
            }else if(item.type=='month' || item.type=='datetime'){
              return '之后';
            }
            return "大于"
          case "lt":
            if(item.type!='month'&&item.type!='datetime'){
              return '小于';
            }else if(item.type=='month' || item.type=='datetime'){
              return '之前';
            }
            return "小于"
          case "ge":
            return '大于等于';
          case "le":
            return '小于等于';
          case "locate":
            return '不包含';
          case "not_null":
            if(!item.yesNo){
              return '不为空';
            }else{
              return '是';
            }
            case "is_null":
            if(!item.yesNo){
              return '为空';
            }else{
              return '否';
            }
            default:
              return '';
        }
      },setDefaultSearchName(){
        if(!this.commonSearch){
          this.searchName = '全部';
          return;
        }
        for(let a in this.commonSearch){
          if(this.commonSearch[a].isAll){
            this.searchName = this.commonSearch[a].title;
            this.commonItem = this.commonSearch[a];
            break;
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>

  .j-super-query-box {
    display: inline-block;
  }

  .j-super-query-modal {

    .j-super-query-history-card {
      /deep/ .ant-card-body,
      /deep/ .ant-card-head-title {
        padding: 0;
      }

      /deep/ .ant-card-head {
        padding: 4px 8px;
        min-height: initial;
      }
    }

    .j-super-query-history-empty {
      /deep/ .ant-empty-image {
        height: 80px;
        line-height: 80px;
        margin-bottom: 0;
      }

      /deep/ img {
        width: 80px;
        height: 65px;
      }

      /deep/ .ant-empty-description {
        color: #afafaf;
        margin: 8px 0;
      }
    }

    .j-super-query-history-tree {

      .j-history-tree-title {
        width: calc(100% - 24px);
        position: relative;
        display: inline-block;

        &-closer {
          color: #999999;
          position: absolute;
          top: 0;
          right: 0;
          width: 24px;
          height: 24px;
          text-align: center;
          opacity: 0;
          transition: opacity 0.3s, color 0.3s;

          &:hover {
            color: #666666;
          }

          &:active {
            color: #333333;
          }
        }

        &:hover {
          .j-history-tree-title-closer {
            opacity: 1;
          }
        }

      }

      /deep/ .ant-tree-switcher {
        display: none;
      }

      /deep/ .ant-tree-node-content-wrapper {
        width: 100%;
      }
    }

    .super-top{
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(230, 237, 245, 1);
      padding: 24px;
      font-size: 14px
    }
    .add-filter{
      height: 48px;
      line-height: 48px;
      background: #E8F1FF;
      color: #0A1629;
      text-align: center;
      font-size: 14px;
      border-radius: 12px;
      cursor: pointer;
    }
    .filter-box{
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      /deep/ .ant-radio-inner{
        width: 21px !important;
        height: 21px !important;
      }
      /deep/ .ant-radio-inner{
        border:2px solid  #0A1629 !important;
      }
      /deep/ .ant-radio-checked .ant-radio-inner{
        border:2px solid  #0A1629 !important;
      }
      /deep/ .ant-radio-inner::after{
        width:10px !important;
        height: 10px !important;
        top:3px !important;
        left: 3.5px !important;
      }
    }

    /deep/ .ant-modal-content{
      border-radius: 12px !important;
    }
    /deep/ .ant-modal-header{
      border-radius:12px 12px 0 0;
      display: none;
    }
    /deep/ .ant-modal-body{
      padding: inherit;
    }

    /deep/ .ant-select-arrow{
      color: #1890ff !important;
    }

  }

  /deep/ .ant-modal-header{
    background: #E6EDF5 !important;
  }

  /* 基础容器样式 - 兼容IE11+、Chrome、Firefox、Safari */
  .customer-filter-panel {
    border-radius: 4px;
    box-sizing: border-box; /* 盒模型兼容 */
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  /* 分组容器 */
  .filter-group {
    margin-bottom: 24px;
  }

  /* 分组标题 */
  .group-title {
    font-size: 14px;
    color: #777777;
    margin-bottom: 8px;
    font-weight: 400;
    line-height: 1.5;
    margin-left: 20px;
  }

  /* 选项列表容器 */
  .filter-list {
    display: flex;
    flex-direction: column;
    gap: 8px; /* 间距 - 兼容现代浏览器，同时做降级 */
  }

  /* 单个选项样式 */
  .filter-item {
    padding: 10px 12px;
    background-color: #ffffff;
    color: #333333;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* 兼容旧浏览器的flex */
    display: -webkit-flex;
    -webkit-justify-content: space-between;
    -webkit-align-items: center;
  }

  /* hover效果 */
  .filter-item:hover {
    background-color: #E6EDF5;
  }

  /* 图标样式 */
  .check-icon {
    color: #00BAAD;
    font-size: 14px;
  }

  .save-icon {
    color: #FFC300;
    font-size: 14px;
    cursor: pointer;
  }

  .edit-icon {
    color: #2A82E4;
    font-size: 14px;
    cursor: pointer;
  }

  /* 降级处理：针对不支持gap的浏览器 */
  .filter-list .filter-item + .filter-item {
    margin-top: 8px;
  }
  /* 整体容器样式 */
  .filter-config-container {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    box-sizing: border-box;
  }

  /* 筛选器名称区域 */
  .filter-name-section {
    margin-bottom: 24px;
  }

  .filter-name-section .label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #777777;
    margin-left: 12px;
  }

  .filter-name-input {
    width: 100%;
    margin-bottom: 16px;
    border-radius: 24px !important;
  }

  .button-group {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }

  /* 删除按钮样式 */
  .delete-btn {
    border: 1px solid #1890ff;
    color: #1890ff;
    background: #ffffff;
    border-radius: 24px;
    padding: 0 40px;
    height: 42px;
  }

  .delete-btn:hover {
    background: #f0f7ff;
    border-color: #40a9ff;
  }

  /* 保存按钮样式 */
  .save-btn {
    background: #1890ff;
    border-color: #1890ff;
    border-radius: 24px;
    padding: 0 40px;
    height: 42px;
  }

  .save-btn:hover {
    background: #40a9ff;
    border-color: #40a9ff;
  }

  /* 包含条件区域 */
  .condition-section .section-title {
    font-size: 14px;
    color: #777777;
    margin-bottom: 8px;
    margin-left: 12px;
  }
  /* 整体容器样式 */
  .description-container {
    width: 100%;
    max-width: 500px; /* 可根据需求调整最大宽度 */
    border-radius: 4px; /* 可选：圆角 */
    font-size: 14px;
    margin-left: 6px;
  }

  /* 每一行的样式 */
  .description-item {
    display: flex; /* Flex 布局，让左右元素并排 */
    margin-bottom: 12px; /* 行间距 */
    align-items: flex-start; /* 顶部对齐 */
  }

  /* 左侧标签（固定宽度） */
  .description-label {
    width: 120px; /* 固定宽度，可根据需求调整 */
    color: #777777; /* 文字颜色 */
    font-weight: 500; /* 可选：加粗 */
    flex-shrink: 0; /* 禁止收缩 */
  }

  /* 右侧内容（固定宽度/自适应） */
  .description-content {
    width: 300px; /* 固定宽度，可根据需求调整；如果要自适应，改为 flex: 1; */
    color: #333333; /* 文字颜色 */
    word-break: break-all; /* 换行，防止内容溢出 */
  }

  /* 最后一行去掉下边距 */
  .description-item:last-child {
    margin-bottom: 0;
  }

  .super-search-btn{
    border-radius: 18px;
    line-height: 36px;height: 36px;
    background: #E6EDF5;
    padding: 0 16px;
    font-size: 14px;
    display: flex;
  }

  .super-search-btn h4{
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    white-space: nowrap;
    display: inline-block;
    margin-top: 6px;
    color: #1890ff;
  }
  .super-search-btn  span{
    display: inline-block;
  }
  //.active{
  //  background: #1890FF !important;
  //  color: #FFFFFF !important;
  //}

  /deep/ .ant-drawer-content{
    background: rgb(244, 249, 253);
  }
</style>